import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Footer = styled.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: ${theme.spacing['2xl']};
  gap: ${theme.spacing.xl};
  border-top: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
